import type { SxProps, Theme } from '@mui/material';

export const spreadCardRootSx: SxProps<Theme> = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  textDecoration: 'none',
  color: 'inherit',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: (theme) => `0 8px 24px ${theme.palette.primary.main}40`,
  },
};

export const spreadCardContentSx: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
};

export const spreadCardTitleSx: SxProps<Theme> = {
  mb: 1,
  fontWeight: 600,
};

export const spreadCardDescriptionSx: SxProps<Theme> = {
  mb: 2,
  flex: 1,
  opacity: 0.9,
};

export const spreadCardCaptionSx: SxProps<Theme> = {
  fontWeight: 600,
  display: 'block',
  mb: 1,
};
